import Link from 'next/link';

export default function TopBar() {
  return (
    <div className="w-full bg-gradient-to-r from-dark to-dark py-[0.125rem]">
      <div className="mx-auto max-w-[90rem] px-[1rem] text-center">
        <p className="text-[0.834rem] font-medium text-white">
          Announcing our $4M Seed Funding backed by Y Combinator, Zillionize, 10x Founders and more. Read more{' '}
          <Link
            href="https://venturebeat.com/virtual/thera-scores-4m-seed-to-make-it-easier-to-hire-and-pay-international-employees/"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer text-therablue underline"
          >
            here
          </Link>
        </p>
      </div>
    </div>
  );
}
